// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__6-UwY","requiredAsterisk":"Info_requiredAsterisk__ynxO3"};